import React, { useEffect } from "react";
import RapiDocReact from "../components/RapidDocReact";
import { Box } from "@mui/material";
import Grid from '@mui/material/Grid2';
import TitleDescription from "../components/TitleDescription";
import Title from "../components/Title";
import TitleDescriptionImage from "../components/TitleDescriptionImage";
import { ReactComponent as ComprehensiveAnalyticsReportingComponent } from "../assets/comprehensive-analytics-reporting.svg"
import { ReactComponent as SeamlessIntegrationWithCBSComponent } from "../assets/seamless-integration-with-cbs.svg"
import { ReactComponent as SeamlessSupport247Component } from "../assets/247-support.svg"
import { ReactComponent as ConnectHubSequenceDiagramComponent } from "../assets/connect-hub-sequence-diagram.svg"
import { useLocation } from "react-router-dom";

function navigateToSection(hash: string) {
    const element = document.getElementById(hash);
    if (element) {
        var headerOffset = 45;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.scrollY - headerOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }
}

const ConnectHubPage: React.FC = React.memo(() => {
    const location = useLocation();
    useEffect(() => {
        if (location.hash.length === 0) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
            return;
        }

        const hash = location.hash.slice(1);
        navigateToSection(hash);
    }, [location.hash]);

    return <>
        <Box sx={{
            paddingLeft: 4
        }}>
            <TitleDescription title="ConnectHub" description="ConnectHub enables institutions to seamlessly integrate into the Account Aggregator (AA) ecosystem as Financial Information Providers (FIPs). Our platform is AA-agnostic, allowing you to connect with multiple Account Aggregators while offering a range of advanced features." />
            <>
                <Title title="Why ConnectHub?" />
                <Grid container spacing={3} paddingTop={1}>
                    <Grid size={4}>
                        <TitleDescriptionImage
                            title="Comprehensive Analytics & Reporting"
                            description="Gain actionable insights with advanced analytics and detailed reporting features. Track key metrics, monitor performance, and generate customized reports to make informed decisions with ease."
                            svg={ComprehensiveAnalyticsReportingComponent}
                            maxWidth={290}
                        />
                    </Grid>
                    <Grid size={4}>
                        <TitleDescriptionImage
                            title="Seamless Integration with Core Banking Systems (CBS)"
                            description="Effortlessly integrate with existing CBS systems using our pre-built connectors, minimizing technical challenges and ensuring a smooth onboarding process."
                            svg={SeamlessIntegrationWithCBSComponent}
                            maxWidth={290}
                        />
                    </Grid>
                    <Grid size={4}>
                        <TitleDescriptionImage
                            title="24/7 Unmatched Support"
                            description="Get round-the-clock support from our expert team, ensuring that your institution stays operational and fully supported at all times without any disruptions."
                            svg={SeamlessSupport247Component}
                            maxWidth={290}
                        />
                    </Grid>
                </Grid>
            </>
            <>
                <Title title="How ConnectHub Works?" paddingBottom={4} paddingTop={6} />
                <ConnectHubSequenceDiagramComponent />
            </>
        </Box>
        <RapiDocReact
            spec-url={"/connecthub.json"}
            show-info={false}
            show-header={false}
            allow-try={false}
            allow-authentication={false}
            allow-server-selection={false}
            render-style="view"
            theme="light"
            primary-color="#6C4FE0"
            bg-color="#FFFFFF"
            text-color="#2C3E50"
            header-color="#1A202C"
            nav-bg-color="#2D3748"
            nav-text-color="#E2E8F0"
            nav-hover-bg-color="#4A5568"
            nav-hover-text-color="#FFFFFF"
            nav-accent-color="#6C4FE0"
            schema-style="table"
            regular-font='"Inter","Roboto","Helvetica","Arial",sans-serif'
            mono-font='"SF Mono","Monaco","Inconsolata","Roboto Mono",monospace'
            font-size="default"
        />
    </>
});

export default ConnectHubPage;
